import { $ } from '../../../src/Framework';
import { Component } from '../../../src/Component';
export class ScrollSpy extends Component {
    constructor(menuElementName, sectionClass, headerHeight) {
        super('ScrollSpyComponent', false);
        this.menuElementName = menuElementName;
        this.sectionClass = sectionClass;
        this.headerHeight = headerHeight;
    }
    async init() {
        await super.init();
        this.link = $(this.menuElementName + ' a');
        this.sections = $(this.sectionClass);
        if (this.link.length == 0 || this.sections.length == 0) {
            this.warning('missing `link` or `sections`');
        }
        else {
            $(window).on('scroll', () => {
                this.spy();
            });
            this.spy();
            this.success();
        }
        this.link.on('click', (event) => {
            event.preventDefault();
            var target = $($(event.target).attr('href'));
            var top = (target.get(0) === this.sections.get(0)) ? 0 : target.position().y - this.headerHeight + 1;
            $.scrollTo(top);
        });
    }
    spy() {
        var currentID = '';
        this.sections.forEach((section) => {
            if (section.getBoundingClientRect().y <= this.headerHeight)
                currentID = $(section).attr('id');
        });
        if (currentID) {
            this.link.removeClass('active').search('[href="#' + currentID + '"]').addClass('active');
        }
    }
}
